import { ContactFloatingBtn } from "@/components/common/ContactFloatingBtn";
import { Footer } from "@/components/layout/Footer";
import { Navbar } from "@/components/layout/Navbar";

export const MainLayout = ({ children }) => {
  return (
    <div className="page-shell">
      <a
        href="#main-content"
        className="absolute left-2 top-2 z-50 -translate-y-20 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground focus:translate-y-0"
        data-testid="skip-to-content-link"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main-content" className="surface-grid" data-testid="main-content-area">
        {children}
      </main>
      <Footer />
      <ContactFloatingBtn />
    </div>
  );
};
